<ng-container *ngIf="!currentUser">
	<div class="container-fluid band p-3">
		<div class="container px-3">
			<div class="row" *ngIf="!currentUser">
				<div class="col-12 col-md-6 text-center">
					<img [src]="introImage" class="img-fluid" alt="{{systemTitle}} ⋆ {{systemSlogan}}" />
				</div>
				<div class="col-12 col-md-5 my-5 my-sm-0 mt-sm-5 d-flex">
					<div class="d-flex align-items-center">
						<div class="d-block">
							<div class="text-white">
								<h2 class="section-title">{{sectionIntro}}</h2>
							</div>
							<p class="mt-3"><a href="{{salesWebsite}}" title="Lees meer over {{systemTitle}}"
									class="btn  btn-success">Meer over {{systemTitle}}</a></p>
						</div>
					</div>
				</div>
			</div>
			<div class="row" *ngIf="currentUser" [innerHTML]="introText"></div>
		</div>
	</div>
</ng-container>
<ng-container *ngIf="currentUser">
	<div *ngIf="banner != null" class="container-fluid band p-3" [style.backgroundColor]="banner.color">
		<div class="container px-3" [ngClass]="{'has-banner-link': banner.link && banner.link.length > 1}">
			<div class="row">
				<div class="col-12 col-md-6 text-center">
					<img (click)="openURL(banner.link)" *ngIf="banner.image && !banner.youtube" class="img-fluid banner-image"
						alt="Afbeelding bij {{banner.title}}"
						[src]="banner.image">

					<iframe style="aspect-ratio: 16 / 9; width: 100%;" *ngIf="banner.youtube" type="text/html"
						[src]="embed(banner.youtube)" frameborder="0"></iframe>
				</div>
				<div class="col-12 col-md-5 my-5 my-sm-0 d-flex">
					<div class="d-flex align-items-center">
						<div class="d-block">
							<div class="text-white">
								<div class="section-title" (click)="openURL(banner.link)" >
									<h2 [innerHTML]="banner.title"></h2>
									<p [innerHTML]="banner.body"></p>
								</div>
							</div>
							<p class="mt-3"><a *ngIf="banner.buttonText" class="btn btn-sm"
									[style.color]="banner.buttonTextColor"
									[style.backgroundColor]="banner.buttonBackgroundColor" [href]="banner.link">{{banner.buttonText}}</a></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="banner == null" class="container-fluid band p-3">
		<div class="container px-3">
			<div class="row" *ngIf="currentUser == false">
				<!-- <div class="col-12 col-md-6 text-center">
					<img [src]="introImage" class="img-fluid" alt="{{systemTitle}} ⋆ {{systemSlogan}}" />
				</div>
				<div class="col-12 col-md-5 my-5 my-sm-0 mt-sm-5 d-flex">
					<div class="d-flex align-items-center">
						<div class="d-block">
							<div class="text-white">
								<h2 class="section-title">Dé methode voor maatschappijleer én maatschappijkunde op het
									vmbo.</h2>
							</div>
							<p class="mt-3"><span class="d-none d-lg-inline"><a href="javascript:;"
										(click)="showLogin()" title="Inloggen voor leerlingen en docenten"
										class="btn btn-primary">Inloggen</a> &nbsp;</span> <a href="{{salesWebsite}}"
									title="Lees meer over {{systemTitle}}" class="btn  btn-info">Meer over
									{{systemTitle}}</a></p>
						</div>
					</div>
				</div> -->
			</div>
			<!-- <div class="row" *ngIf="currentUser" [innerHTML]="introText"></div> -->
		</div>
	</div>
</ng-container>

<section class="container-fluid main sections" *ngIf="frontType != 'CHAPTER'">

	<div class="container py-5">
		<section class="no-modules-container" *ngIf="topSectionsIsLoaded && topSections.length == 0">
			<div class="alert alert-warning d-none" *ngIf="currentUser && currentUser['role'] == 'STUDENT'">Deze klas
				heeft nog geen modules toegewezen gekregen. Roep je docent er even bij!</div>
			<div class="alert alert-warning" *ngIf="currentUser && currentUser['role'] != 'STUDENT'">Er zijn op dit
				moment geen actieve licenties voor deze school. Als er wel een bestelling is geplaatst, <a href="https://uitgeverijneo.nl/contact">neem
					dan contact met ons op</a>.</div>
		</section>

		<section class="last-lesson-alert-container" *ngIf="currentUser && currentUser['lastLessonId']"
			[ngClass]="{'bg-info': currentUser['lastLessonImage'] == ''}">
			<a routerLink="/les/{{currentUser['lastLessonId']}}"
				[style.background-image]="'url(' + currentUser['lastLessonImage'] + ')'">
				<span class="routingText">Je bent gebleven bij</span>
				<span class="routingTitle">{{currentUser['lastLessonName']}}</span>
			</a>
		</section>

		<div *ngFor="let section of topSections let i = index">
			<div *ngIf="section.chapters.length > 0">
				<h2 class="mb-4">{{section.name}}</h2>
				<div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">

					<div class="col mb-5" *ngFor="let chapter of section.chapters let i = index">
						<div class="card" [ngClass]="{
						'no-license': activeChapterIds[chapter['id']] != true && checkLicense == true
					}">
							<img src="{{chapter.thumb}}" class="card-img-top" alt="{{chapter.name}}">
							<div class="card-body p-4">
								<h3 class="card-title">{{chapter.name}}</h3>
								<p class="card-text">{{chapter.description}}</p>
							</div>
							<div class="mt-auto m-4">
								<a *ngIf="chapter['layout'] != 'OVERVIEW'" routerLink="/les/{{chapter.firstLessonId}}"
									class="btn btn-card stretched-link px-3" title="Ga naar module {{chapter.name}}">Ga
									naar deze module <i class="fas fa-caret-right"></i></a>
								<a *ngIf="chapter['layout'] == 'OVERVIEW'" routerLink="/module/{{chapter['slug']}}"
									class="btn btn-card stretched-link px-3" title="Ga naar deze module">Ga naar deze
									module <i class="fas fa-caret-right"></i></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section *ngIf="highlightLessons">
	<div class="container-fluid band choiceBG keuzeopdrachten p-3" *ngIf="frontType != 'CHAPTER'">
		<div class="container carouselContainer px-3 my-5">
			<img src="assets/images/speaker.png" alt="speaker">
			<h2 class="mb-4">Actueel</h2>
			<ngb-carousel [pauseOnHover]="true" [showNavigationArrows]="false" [showNavigationIndicators]="true">
				<ng-template ngbSlide *ngFor="let _ of [].constructor(getCarouselSize()); index as i">
					<div *ngFor="let card of splitCarouselAtIndex(i)" class="carouselCard" [ngStyle]="{'background-image': 'url(' + card.image + ')'}">
						<a href="/les/{{card['id']}}" class="carouselCard__link">
							<div class="mt-auto m-4">
								<p class="btn btn-card stretched-link px-3">{{card.name}}<i class="fas fa-caret-right"></i></p>
							</div>
						</a>
					</div>
				</ng-template>
			</ngb-carousel>
		</div>
	</div>
</section>

<section class="container-fluid main sections" *ngIf="frontType != 'CHAPTER'">
	<div class="container py-5">

		<div *ngFor="let section of bottomSections let i = index">
			<div *ngIf="section.chapters.length > 0">
				<h2 class="mb-4">{{section.name}}</h2>
				<div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">

					<div class="col mb-5" *ngFor="let chapter of section.chapters let i = index">
						<div class="card" [ngClass]="{
						'no-license': activeChapterIds[chapter['id']] != true && checkLicense == true
					}">
							<img src="{{chapter.thumb}}" class="card-img-top" alt="{{chapter.name}}">
							<div class="card-body p-4">
								<h3 class="card-title">{{chapter.name}}</h3>
								<p class="card-text">{{chapter.description}}</p>
							</div>
							<div class="mt-auto m-4">
								<a *ngIf="chapter['layout'] != 'OVERVIEW'" routerLink="/les/{{chapter.firstLessonId}}"
									class="btn btn-card stretched-link px-3" title="Ga naar module {{chapter.name}}">Ga
									naar deze module <i class="fas fa-caret-right"></i></a>
								<a *ngIf="chapter['layout'] == 'OVERVIEW'" routerLink="/module/{{chapter['slug']}}"
									class="btn btn-card stretched-link px-3" title="Ga naar deze module">Ga naar deze
									module <i class="fas fa-caret-right"></i></a>
							</div>
						</div>
					</div>

				</div>

			</div>
		</div>
	</div>
</section>

<div class="container py-5" *ngIf="frontTypeChapter && frontType == 'CHAPTER'">
	<div class="row">
		<ng-container *ngFor="let lesson of frontTypeChapter['lessons']">
			<div class="mb-4 col-md-6" [ngClass]="{
				'col-xl-4': frontTypeChapter['style'] == '3_COLUMN',
				'col-xl-6': frontTypeChapter['style'] != '3_COLUMN'
			}">
				<div class="card">
					<img src="{{lesson['image']}}" class="card-img-top" alt="{{lesson['name']}}" />
					<div class="card-body p-5">
						<h3 class="card-title" style="font-size: 150%;">{{lesson['name']}}</h3>
						<p class="card-text" [innerHTML]="text(lesson['description'])">
						</p>
					</div>
					<div class="mt-auto m-5">
						<a href="/les/{{lesson['id']}}" class="btn btn-card stretched-link px-3"
							title="Ga naar deze les">
							Ga naar deze les <i class="fas fa-caret-right"></i>
						</a>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>